<template>
  <div
    :style="{ backgroundColor: backColor }"
    class="t-l_auto iframe-container"
  >
    <iframe
      v-if="canLoad"
      :id="`xx-iframe-${pageKey}`"
      ref="iframe"
      :key="`${pageKey}@${count}`"
      v-bind="attrs"
      class="xx-iframe"
      :src="url"
      :name="targetName"
      owl-ignore
      @load="onLoaded"
      @error="onError"
    ></iframe>
    <!-- 暂时先隐藏这里的插槽，待权限功能改造到现有组件库之后再放开 -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "XxContainer",
  inject: ["$$event", "$xxEvent", "$xxRouter"],
  provide() {
    return {
      $xxTabView: this,
    };
  },
  props: {
    pageKey: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "灯塔",
    },
    url: {
      type: String,
      required: true,
    },
    targetName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    backColor: {
      type: String,
      default: "#fff",
    },
    active: {
      type: Boolean,
      default: false,
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    // 用于消除 iframe url 变化带来的 history 的问题
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      canLoad: false,
      firstLoaded: false,
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.canLoad = true;
      }
    },
    canLoad(val) {
      if (val) {
        this.updateEventTarget();
      }
    },
    count() {
      this.updateEventTarget();
    },
  },
  created() {
    if (this.active) {
      this.canLoad = true;
    }
  },
  beforeUnmount() {
    this.$xxEvent.removeTarget(this.pageKey);
  },
  methods: {
    reload() {
      this.$refs.iframe &&
        this.$refs.iframe.contentWindow &&
        this.$refs.iframe.contentWindow.location.reload();
    },
    onLoaded() {
      if (!this.firstLoaded) {
        this.firstLoaded = true;
      }
      this.updateEventTarget();
      this.$xxRouter.loader.updatePage(this.pageKey, { loading: false });
      // eslint-disable-next-line vue/require-slots-as-functions
      if (this.$slots.default && this.$slots.default.length) {
        // eslint-disable-next-line vue/require-slots-as-functions
        const ref = this.$slots.default[0].componentInstance;
        if (
          ref &&
          ref.getHelperInfo &&
          typeof ref.getHelperInfo === "function"
        ) {
          ref.getHelperInfo();
        }
      }
    },
    onError(...args) {
      this.$$event.$("$app.error", this.pageKey, args);
    },
    updateEventTarget() {
      this.$nextTick(() => {
        if (!this.$refs.iframe) {
          return;
        }
        this.$xxEvent.addTarget(this.$refs.iframe.contentWindow, this.pageKey);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.t-l_auto {
  flex: 1;
}

.iframe-container {
  overflow: hidden;
  position: relative;
  height: 100%;
}

.xx-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  border: 0;
  // z-index: 1;
  z-index: 3; // .el-tabs__nav 为 2
}

#xx-iframe.full-window,
.xx-iframe.full-window {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  position: fixed !important;
}
</style>
